import {
  Card,
  CardBody,
  Typography,
  Button,
} from "@material-tailwind/react";
import { CalendarDaysIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { useSelector } from "react-redux";

export function StoryCard({ story }) {
  const languageCode = useSelector((state) => state?.combineReducer?.clientLanguage?.data);
  return (
    <Card className="w-full max-w-sm overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-shadow">
      {/* Image */}
      <div className="aspect-[4/3] w-full overflow-hidden">
        <img
          src={story.imgUrl}
          alt={story.title}
          className="h-full w-full object-cover"
        />
      </div>

      <CardBody className="flex flex-col gap-3 p-4">
        {/* Date */}
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <CalendarDaysIcon className="h-4 w-4" />
          {new Date(story.publishDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>

        {/* Title */}
        <Typography
          variant="h6"
          className="line-clamp-2 text-base font-semibold"
        >
          {story.title}
        </Typography>

        {/* Description */}
        <Typography
          variant="small"
          className="line-clamp-3 text-sm text-gray-600"
        >
          {story.description}
        </Typography>

        {/* Action */}
        <a
          href={story.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2"
        >
          <Button
            size="sm"
            variant="outlined"
            fullWidth
            className="flex items-center justify-center gap-2"
          >
            {
                languageCode == 1033 ? "Read More" : "Selengkapnya"
            }
            
            <ArrowTopRightOnSquareIcon className="h-4 w-4" />
          </Button>
        </a>
      </CardBody>
    </Card>
  );
}
